import { useState } from "react";
import { ChevronLeft } from "lucide-react";

const SIZES = [[null, 38], [39, 41], [42, null]];
const sizeLabel = ([a, b], L) => (!a ? `${L === "en" ? "Up to" : "Até"} ${b} mm` : b ? `${a}–${b} mm` : `${a} mm +`);
const sizeMsg = ([a, b], lang) => (lang === "en"
  ? (!a ? `I am looking for a watch with a case up to ${b} mm.` : b ? `I am looking for a watch with a case between ${a} and ${b} mm.` : `I am looking for a watch with a case of ${a} mm or more.`)
  : (!a ? `Procuro um relógio com caixa até ${b} mm.` : b ? `Procuro um relógio com caixa entre ${a} e ${b} mm.` : `Procuro um relógio com caixa de ${a} mm ou mais.`));

const Chip = ({ children, ...p }) => (
  <button type="button" className="shrink-0 whitespace-nowrap rounded-full border border-[#C8AE6E]/35 px-3.5 py-1.5 text-[11px] tracking-[0.05em] text-[#E6D5AC] transition-[background-color,border-color] duration-300 [@media(hover:hover)]:hover:bg-[#C8AE6E]/10 [@media(hover:hover)]:hover:border-[#C8AE6E] active:bg-[#C8AE6E]/15 disabled:opacity-40" {...p}>{children}</button>
);

export function Suggestions({ items, lang, disabled, onSend, sizeQ }) {
  const [sizes, setSizes] = useState(false);
  if (!items?.length) return null;
  const L = lang === "en" ? "en" : "pt";
  return (
    <div className="border-t border-[#282520] px-4 pt-3" data-testid="advisor-suggestions">
      {sizes && <p className="text-[11px] text-[#A39E93] mb-2" data-testid="advisor-size-question">{sizeQ}</p>}
      <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] sm:flex-wrap sm:overflow-visible">
        {sizes ? (
          <>
            <Chip onClick={() => setSizes(false)} aria-label="back" data-testid="advisor-size-back"><ChevronLeft className="w-3.5 h-3.5" /></Chip>
            {SIZES.map((s) => <Chip key={s[1] || s[0]} disabled={disabled} onClick={() => { setSizes(false); onSend(sizeMsg(s, L)); }} data-testid={`advisor-size-${s[0] || 0}`}>{sizeLabel(s, L)}</Chip>)}
          </>
        ) : items.map((x) => (
          <Chip key={x.id} disabled={disabled} onClick={() => (x.kind === "size" ? setSizes(true) : onSend(x[`prompt_${L}`]))} data-testid={`advisor-suggestion-${x.id}`}>{x[`label_${L}`]}</Chip>
        ))}
      </div>
    </div>
  );
}
